import type { IntlShape } from 'react-intl';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';

import { i18n } from '../errorFlagMessages.ts';

export const showInvalidMoveManagedFolderFlag = (
	flags: FlagsStateContainer,
	intl: IntlShape,
): void => {
	void flags.showErrorFlag({
		title: intl.formatMessage(i18n.flagInvalidMoveManagedFolderTitle),
		description: intl.formatMessage(i18n.flagInvalidMoveManagedFolderDescription),
		isAutoDismiss: true,
	});
};
